/* eslint-disable react/display-name */
import React, { Fragment } from 'react';
import convert from 'htmr';
import IconChevron from '../../files/chevron.svg';

/* eslint-disable no-console */
const Button = ({
  disabled,
  text,
  children,
  proxy,
  className = 'btn btn--default',
  href,
  onClick,
  ...props
}) => {
  const Tag = href ? 'a' : 'button';
  return (
    <Tag
      disabled={disabled}
      onClick={onClick}
      className={className}
      href={href}
      {...props}
    >
      {children ||
        (text && (
          <Fragment>
            <span>{text}</span>
            <IconChevron
              className="btn__icon--default"
              height="15"
              width="8"
              viewBox="0 0 6 11"
              focusable={false}
            />
          </Fragment>
        )) ||
        convert(proxy.innerHTML.trim())}
    </Tag>
  );
};
/* eslint-enable no-console */

export default Button;
